import { getByPath } from "@coworker/apprestructured/src/shared/helpers/object.helper";
import { isLoading } from "@coworker/apprestructured/src/task-management/loading";
import { ViewerTopFragmentCommonProps } from "../viewer-top-fragment/ViewerTopFragment";
import { ItemCardWithCopyNo } from "@coworker/apprestructured/src/shared/components/item-cards/ItemCardWithCopyNo/ItemCardWithCopyNo";
import { ItemNoAndType } from "@coworker/apprestructured/src/task-management/types/TaskDetailTypes";
import { useItemInfo } from "@coworker/apprestructured/src/shared/hooks/item/useItemInfo";
import TopFragmentWrapper from "../../../SheetTop/TopFragmentWrapper/TopFragmentWrapper";
import TaskState from "@coworker/apprestructured/src/task-management/types/TaskState";
import styles from "./ArticleViewerTopFragment.module.css";
import { getTypedValue } from "@coworker/apprestructured/src/shared/helpers/schemaValidator";

export type ArticleViewerTopFragmentConfigProps = {
  field: string;
};

type ArticleViewerTopFragmentProps = {
  configProps: ArticleViewerTopFragmentConfigProps;
  commonProps: ViewerTopFragmentCommonProps;
};

function ArticleViewerTopFragment({
  configProps,
  commonProps,
}: ArticleViewerTopFragmentProps) {
  const { field } = configProps;
  const { task } = commonProps;
  const itemNoAndType = getTypedValue<ItemNoAndType>(getByPath(task, field));
  const state = getTypedValue<TaskState>(getByPath(task, "state"));

  const { data: item } = useItemInfo((itemNoAndType as ItemNoAndType)?.no);

  if (!item || isLoading(item)) return null;

  return (
    <TopFragmentWrapper state={state}>
      <div className={styles["card"]}>
        <ItemCardWithCopyNo item={item} />
      </div>
    </TopFragmentWrapper>
  );
}

export default ArticleViewerTopFragment;
